import { createRouter, createWebHistory } from 'vue-router'

import SplashView from '../views/SplashView.vue'
import LanguageView from '../views/LanguageView.vue'
import LoginView from '../views/LoginView.vue'
import OtpView from '../views/OtpView.vue'
import RegisterView from '../views/RegisterView.vue'
import HomeView from '../views/HomeView.vue'
import GradesListView from '../views/GradesListView.vue'
import GradeCoursesView from '../views/GradeCoursesView.vue'
import CourseLessonsView from '../views/CourseLessonsView.vue'
import LessonDetailView from '../views/LessonDetailView.vue'
import TeachersListView from '../views/TeachersListView.vue'
import TeacherProfileView from '../views/TeacherProfileView.vue'
import TeacherPostsView from '../views/TeacherPostsView.vue'
import UserProfileView from '../views/UserProfileView.vue'
import EditProfileView from '../views/EditProfileView.vue'
import ExamsView from '../views/ExamsView.vue'
import CertificateView from '../views/CertificateView.vue'
import ContactView from '../views/ContactView.vue'
import ChatView from '../views/ChatView.vue'
import BookmarksView from '../views/BookmarksView.vue'
import LessonsProgressView from '../views/LessonsProgressView.vue'
import UserQuestionsView from '../views/UserQuestionsView.vue'
import ChartLessonsListView from '../views/ChartLessonsListView.vue'
import LessonChartView from '../views/LessonChartView.vue'
import InfoView from '../views/InfoView.vue'

import TeacherLoginView from '../views/teacher/LoginView.vue'
import TeacherOtpView from '../views/teacher/OtpView.vue'
import TeacherRegisterView from '../views/teacher/SplashScreen.vue'
import TeacherHomeView from '../views/teacher/HomePage.vue'
import TeacherUserAreaView from '../views/teacher/UserArea.vue'
import TeacherMyProfileView from '../views/teacher/MyProfile.vue'
import TeacherAddPostView from '../views/teacher/AddPost.vue'
import TeacherAttachReportView from '../views/teacher/AttachReport.vue'
import TeacherChatDetailView from '../views/teacher/ChatDetail.vue'
import TeacherCourseQAView from '../views/teacher/CourseQA.vue'
import TeacherEditProfileInfoView from '../views/teacher/EditProfileInfo.vue'
import TeacherExamListView from '../views/teacher/ExamList.vue'
import TeacherFollowersListView from '../views/teacher/FollowersList.vue'
import TeacherLikesListView from '../views/teacher/LikesList.vue'
import TeacherMyChatsView from '../views/teacher/MyChats.vue'
import TeacherPostDetailView from '../views/teacher/PostDetail.vue'
import TeacherReportDetailView from '../views/teacher/ReportDetail.vue'
import TeacherRequestSubjectView from '../views/teacher/RequestSubject.vue'
import TeacherStatusView from '../views/teacher/TeacherStatus.vue'
import TeacherContactView from '../views/teacher/ContactView.vue'

const routes = [
  { path: '/', name: 'Splash', component: SplashView },
  { path: '/language', name: 'Language', component: LanguageView },
  { path: '/login', name: 'Login', component: LoginView },
  { path: '/otp', name: 'Otp', component: OtpView },
  { path: '/register', name: 'Register', component: RegisterView },
  { path: '/home', name: 'Home', component: HomeView },
  { path: '/grades', name: 'GradesList', component: GradesListView },
  { path: '/grade-courses/:gradeId', name: 'GradeCourses', component: GradeCoursesView },
  { path: '/course-lessons/:lessonId', name: 'CourseLessons', component: CourseLessonsView },
  { path: '/lesson/:id', name: 'LessonDetail', component: LessonDetailView },
  { path: '/teachers', name: 'TeachersList', component: TeachersListView },
  { path: '/teacher-profile/:id', name: 'TeacherProfile', component: TeacherProfileView },
  { path: '/teacher-posts/:id', name: 'TeacherPosts', component: TeacherPostsView },
  { path: '/profile', name: 'UserProfile', component: UserProfileView },
  { path: '/edit-profile', name: 'EditProfile', component: EditProfileView },
  { path: '/exams', name: 'Exams', component: ExamsView },
  { path: '/certificate', name: 'Certificate', component: CertificateView },
  { path: '/contact', name: 'Contact', component: ContactView },
  { path: '/chat/:teacherId', name: 'Chat', component: ChatView },
  { path: '/bookmarks', name: 'Bookmarks', component: BookmarksView },
  { path: '/lessons-progress', name: 'LessonsProgress', component: LessonsProgressView },
  { path: '/user-questions', name: 'UserQuestions', component: UserQuestionsView },
  { path: '/chart-lessons', name: 'ChartLessonsList', component: ChartLessonsListView },
  { path: '/lesson-chart/:lessonId', name: 'LessonChart', component: LessonChartView },
  { path: '/info/:pageType', name: 'Info', component: InfoView },

  { path: '/teacher/login', name: 'TeacherLogin', component: TeacherLoginView },
  { path: '/teacher/otp', name: 'TeacherOtp', component: TeacherOtpView },
  { path: '/teacher/register', name: 'TeacherRegister', component: TeacherRegisterView },
  { path: '/teacher/home', name: 'TeacherHome', component: TeacherHomeView },
  { path: '/teacher/user-area', name: 'TeacherUserArea', component: TeacherUserAreaView },
  { path: '/teacher/my-profile', name: 'TeacherMyProfile', component: TeacherMyProfileView },
  { path: '/teacher/add-post', name: 'TeacherAddPost', component: TeacherAddPostView },
  { path: '/teacher/attach-report', name: 'TeacherAttachReport', component: TeacherAttachReportView },
  { path: '/teacher/chat-detail', name: 'TeacherChatDetail', component: TeacherChatDetailView },
  { path: '/teacher/course-qa', name: 'TeacherCourseQA', component: TeacherCourseQAView },
  { path: '/teacher/edit-profile-info', name: 'TeacherEditProfileInfo', component: TeacherEditProfileInfoView },
  { path: '/teacher/exam-list', name: 'TeacherExamList', component: TeacherExamListView },
  { path: '/teacher/followers', name: 'TeacherFollowersList', component: TeacherFollowersListView },
  { path: '/teacher/likes', name: 'TeacherLikesList', component: TeacherLikesListView },
  { path: '/teacher/my-chats', name: 'TeacherMyChats', component: TeacherMyChatsView },
  { path: '/teacher/post-detail', name: 'TeacherPostDetail', component: TeacherPostDetailView },
  { path: '/teacher/report-detail', name: 'TeacherReportDetail', component: TeacherReportDetailView },
  { path: '/teacher/request-subject', name: 'TeacherRequestSubject', component: TeacherRequestSubjectView },
  { path: '/teacher/status', name: 'TeacherStatus', component: TeacherStatusView },
  { path: '/teacher/contact', name: 'TeacherContact', component: TeacherContactView },
  { path: '/teacher/rules', name: 'TeacherRules', component: InfoView, props: { pageType: 'teacher_rules' } },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0 }
  }
})

const publicPages = ['Splash', 'Language', 'Login', 'Otp', 'Register', 'TeacherLogin', 'TeacherOtp', 'TeacherRegister'];

router.beforeEach((to, from, next) => {
  const userId = localStorage.getItem('user_id');
  if (!publicPages.includes(to.name) && !userId) {
    next({ name: 'Language' });
  } else {
    next();
  }
});

export default router